import { Page } from "./components/pages/page";
import { Home } from "./pages/home/home";
import { DataAnalytics } from "./pages/dataAnalytics/dataAnalytics";
import { Pages } from "./components/pages/pages";
import 'lenis/dist/lenis.css'
import "./App.css";
import { NotFound } from "./pages/notFound/notFound";
import { Dashboard } from "./pages/dashboard/dashboard";
import { Contact } from "./pages/contact/contact";
import { WebDevelopment } from "./pages/webDevelopment/webDevelopment";

function App() {

  return (
    <Pages>
      <Page Component={Home}>
        <Page 
          title="data-analytics" 
          Component={DataAnalytics}
        >
          <Page title="dashboard" Component={Dashboard} />
        </Page>
        
        <Page title="web-development" Component={WebDevelopment} />
        <Page title="contact" Component={Contact} noBottomInfo />

        <Page 
          Component={NotFound}
          title="not-found"
          noBottomInfo
        />
      </Page>
    </Pages>
  );
}

export default App;
